__webpack_require__.p = "/studentportal/";